import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { TransformedNoContentOption } from '@flows/core/types/stepContentTypes'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_Drone } from '@flows/insurance/schemas'

const DRONE_WEIGHT_OPTIONS: TransformedNoContentOption[] = [
  {
    label: {
      type: 'translatableText',
      translationKey: 'sharedFlows_drone:steps.less_than_five_kg',
    },
    value: 'no',
  },
  {
    label: {
      type: 'translatableText',
      translationKey: 'sharedFlows_drone:steps.more_than_five_kg',
    },
    value: 'yes',
  },
]

const drone_weight = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getHelperPath('weight_is_too_high')]:
        BaseSchema_Drone.shape.weight_is_too_high.unwrap(),
    }),
    stepContent: [
      {
        type: 'title',
        text: { type: 'translatableText', translationKey: 'sharedFlows_drone:steps.weight.title' },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        options: DRONE_WEIGHT_OPTIONS,
        name: params.helperFunctions.getHelperPath('weight_is_too_high'),
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: params.helperFunctions.getHelperPath('weight_is_too_high'),
      valueToStepName: {
        no: 'liability_zip',
        yes: 'failure',
      },
    },
  }) as const satisfies AnyStepConfiguration

export default drone_weight
